import { BaseEncoder } from "./BaseEncoder";
import { BaseObjectEncoder } from "./BaseObjectEncoder";
import { DefaultBaseObjectEncoderImpl } from "./DefaultBaseObjectEncoderImpl";

import { TradeQueryRequestImpl } from "../model/impl/TradeQueryRequestImpl";
import { Encodable } from "../model/Encodable";

import * as CubiqTS from "../index";

export class TradeQueryRequestImplEncoder implements BaseEncoder {
  public baseEncoder: BaseObjectEncoder = new DefaultBaseObjectEncoderImpl();

  private static _instance;

  private constructor() {}

  public static get Instance() {
    // Do you need arguments? Make it a regular method instead.
    return this._instance || (this._instance = new this());
  }

  public encode(encodable: TradeQueryRequestImpl, streamout: CubiqTS.ByteBuffer): void {
    this.baseEncoder.encode(encodable, streamout);

    this.baseEncoder.writeStartEncoding(streamout);

    /*Object encoding*/
    if (encodable.messageId != null) {
      this.baseEncoder.writeStartFid(100, streamout);
      this.baseEncoder.writeObject(
        false,
        TradeQueryRequestImplEncoder.fidTypeMap.get(100),
        false,
        encodable.messageId,
        streamout,
      );
      this.baseEncoder.writeEndFid(100, streamout);
    }
    /*Object encoding*/
    if (encodable.brokerId != null) {
      this.baseEncoder.writeStartFid(200, streamout);
      this.baseEncoder.writeObject(
        false,
        TradeQueryRequestImplEncoder.fidTypeMap.get(200),
        false,
        encodable.brokerId,
        streamout,
      );
      this.baseEncoder.writeEndFid(200, streamout);
    }
    /*Object encoding*/
    if (encodable.secureToken != null) {
      this.baseEncoder.writeStartFid(300, streamout);
      this.baseEncoder.writeObject(
        false,
        TradeQueryRequestImplEncoder.fidTypeMap.get(300),
        true,
        encodable.secureToken,
        streamout,
      );
      this.baseEncoder.writeEndFid(300, streamout);
    }
    /*Object encoding*/
    if (encodable.queryGroup != null) {
      this.baseEncoder.writeStartFid(500, streamout);
      this.baseEncoder.writeObject(
        false,
        TradeQueryRequestImplEncoder.fidTypeMap.get(500),
        true,
        encodable.queryGroup,
        streamout,
      );
      this.baseEncoder.writeEndFid(500, streamout);
    }
    /*Object encoding*/
    if (encodable.maxResponseSize != null) {
      this.baseEncoder.writeStartFid(501, streamout);
      this.baseEncoder.writeObject(
        false,
        TradeQueryRequestImplEncoder.fidTypeMap.get(501),
        false,
        encodable.maxResponseSize,
        streamout,
      );
      this.baseEncoder.writeEndFid(501, streamout);
    }
    /*Object encoding*/
    if (encodable.maxTotalResults != null) {
      this.baseEncoder.writeStartFid(502, streamout);
      this.baseEncoder.writeObject(
        false,
        TradeQueryRequestImplEncoder.fidTypeMap.get(502),
        false,
        encodable.maxTotalResults,
        streamout,
      );
      this.baseEncoder.writeEndFid(502, streamout);
    }
    /*Object encoding*/
    if (encodable.querySort != null) {
      this.baseEncoder.writeStartFid(503, streamout);
      this.baseEncoder.writeObject(
        false,
        TradeQueryRequestImplEncoder.fidTypeMap.get(503),
        true,
        encodable.querySort,
        streamout,
      );
      this.baseEncoder.writeEndFid(503, streamout);
    }
    /*Object encoding*/
    if (encodable.proxySessionId != null) {
      this.baseEncoder.writeStartFid(999, streamout);
      this.baseEncoder.writeObject(
        false,
        TradeQueryRequestImplEncoder.fidTypeMap.get(999),
        false,
        encodable.proxySessionId,
        streamout,
      );
      this.baseEncoder.writeEndFid(999, streamout);
    }
    /*Object encoding*/
    if (encodable.svrRxTime != null) {
      this.baseEncoder.writeStartFid(10000, streamout);
      this.baseEncoder.writeObject(
        false,
        TradeQueryRequestImplEncoder.fidTypeMap.get(10000),
        false,
        encodable.svrRxTime,
        streamout,
      );
      this.baseEncoder.writeEndFid(10000, streamout);
    }
    /*Object encoding*/
    if (encodable.svrTxTime != null) {
      this.baseEncoder.writeStartFid(10001, streamout);
      this.baseEncoder.writeObject(
        false,
        TradeQueryRequestImplEncoder.fidTypeMap.get(10001),
        false,
        encodable.svrTxTime,
        streamout,
      );
      this.baseEncoder.writeEndFid(10001, streamout);
    }
    /*Object encoding*/
    if (encodable.cliTxTime != null) {
      this.baseEncoder.writeStartFid(10002, streamout);
      this.baseEncoder.writeObject(
        false,
        TradeQueryRequestImplEncoder.fidTypeMap.get(10002),
        false,
        encodable.cliTxTime,
        streamout,
      );
      this.baseEncoder.writeEndFid(10002, streamout);
    }
    /*Object encoding*/
    if (encodable.cliRxTime != null) {
      this.baseEncoder.writeStartFid(10003, streamout);
      this.baseEncoder.writeObject(
        false,
        TradeQueryRequestImplEncoder.fidTypeMap.get(10003),
        false,
        encodable.cliRxTime,
        streamout,
      );
      this.baseEncoder.writeEndFid(10003, streamout);
    }
    /*Object encoding*/
    if(encodable.sessionOnly!=null){
        this.baseEncoder.writeStartFid(10010,streamout);
        this.baseEncoder.writeObject(false,TradeQueryRequestImplEncoder.fidTypeMap.get(10010),false,encodable.sessionOnly,streamout);
        this.baseEncoder.writeEndFid(10010,streamout);
    }
    this.baseEncoder.writeEndEncoding(streamout);
  }

  static fidTypeMap: Map<number, string> = new Map<number, string>([
    [100, "java.lang.String"],
    [200, "java.lang.String"],
    [300, "com.bcdfx.security.SecureToken"],
    [500, "com.bcdfx.model.query.QueryGroup"],
    [501, "java.lang.Integer"],
    [502, "java.lang.Integer"],
    [503, "com.bcdfx.model.query.QuerySort"],
    [999, "java.lang.String"],
    [10000, "java.lang.Long"],
    [10001, "java.lang.Long"],
    [10002, "java.lang.Long"],
    [10003, "java.lang.Long"],
    [10010, "java.lang.String"],
  ]);

  /**
   * Constructs the event from a given byte stream
   */
  public decode(encodable: TradeQueryRequestImpl, streamin: CubiqTS.ByteBuffer): void {
    this.baseEncoder.decode(encodable, streamin);

    while (true) {
      let ct: string = this.baseEncoder.readCtrl(streamin);
      if (ct == "^F") {
        break;
      }
      if (ct == "^H") continue;
      let fid: number = this.baseEncoder.parseCtrlAsFid(ct);
      if (this.supportsFid(fid) == false) this.baseEncoder.seekToNextFid(fid, streamin);
      switch (fid) {
        case 100: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            TradeQueryRequestImplEncoder.fidTypeMap.get(100),
            streamin,
          );
          encodable.messageId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 200: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            TradeQueryRequestImplEncoder.fidTypeMap.get(200),
            streamin,
          );
          encodable.brokerId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 300: {
          /*Object encoding*/
          let val: CubiqTS.SecureToken = this.baseEncoder.readObject(
            true,
            false,
            TradeQueryRequestImplEncoder.fidTypeMap.get(300),
            streamin,
          );
          encodable.secureToken = <CubiqTS.SecureToken>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 500: {
          /*Object encoding*/
          let val: CubiqTS.QueryGroup = this.baseEncoder.readObject(
            true,
            false,
            TradeQueryRequestImplEncoder.fidTypeMap.get(500),
            streamin,
          );
          encodable.queryGroup = <CubiqTS.QueryGroup>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 501: {
          /*Object encoding*/
          let val: number = this.baseEncoder.readObject(
            false,
            false,
            TradeQueryRequestImplEncoder.fidTypeMap.get(501),
            streamin,
          );
          encodable.maxResponseSize = <number>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 502: {
          /*Object encoding*/
          let val: number = this.baseEncoder.readObject(
            false,
            false,
            TradeQueryRequestImplEncoder.fidTypeMap.get(502),
            streamin,
          );
          encodable.maxTotalResults = <number>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 503: {
          /*Object encoding*/
          let val: CubiqTS.QuerySort = this.baseEncoder.readObject(
            true,
            false,
            TradeQueryRequestImplEncoder.fidTypeMap.get(503),
            streamin,
          );
          encodable.querySort = <CubiqTS.QuerySort>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 999: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            TradeQueryRequestImplEncoder.fidTypeMap.get(999),
            streamin,
          );
          encodable.proxySessionId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10000: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            TradeQueryRequestImplEncoder.fidTypeMap.get(10000),
            streamin,
          );
          encodable.svrRxTime = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10001: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            TradeQueryRequestImplEncoder.fidTypeMap.get(10001),
            streamin,
          );
          encodable.svrTxTime = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10002: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            TradeQueryRequestImplEncoder.fidTypeMap.get(10002),
            streamin,
          );
          encodable.cliTxTime = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10003: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            TradeQueryRequestImplEncoder.fidTypeMap.get(10003),
            streamin,
          );
          encodable.cliRxTime = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10010:
        {
            /*Object encoding*/
            let val_10010:string=this.baseEncoder.readObject(false,false,TradeQueryRequestImplEncoder.fidTypeMap.get(10010),streamin);
            encodable.sessionOnly=val_10010;
            this.baseEncoder.readEndFid(streamin);
            break;
        }
      }
    }
  }

  private supportsFid(fid: number): boolean {
    return TradeQueryRequestImplEncoder.fidTypeMap.has(fid);
  }
}
